import { render, staticRenderFns } from "./MonitoringKebakaranUpdate.vue?vue&type=template&id=aff80b22"
import script from "./MonitoringKebakaranUpdate.vue?vue&type=script&lang=js"
export * from "./MonitoringKebakaranUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports